import { useFiles } from '@/entities/file';
import { useNotices } from '@/features/notices/useNotices';
import { useSjActions } from '@/shared/lib/sj-orm/hooks/useSjActions';
import { FileMetaInfoDto } from '@/shared/lib/sj-orm/models/file-meta-info.dto';
import { AssetPhoto } from '@/widgets/gallery/Photos';

export const useFetchAssetPhotos = () => {
  const { decryptDocumentFile } = useFiles();
  const sjFiles = useSjActions('fileMetaInfos');
  const notices = useNotices();

  const getPhotos = async (paths: string[]) => {
    const filesMetaInfos: FileMetaInfoDto[] = sjFiles.findMany((item) =>
      Boolean(paths.includes(item.filePath)),
    );

    const promises = filesMetaInfos.map(
      (metaDto): Promise<AssetPhoto> =>
        new Promise((resolve, reject) => {
          decryptDocumentFile(metaDto.filePath, { name: metaDto.name })
            .then((file) => {
              if (!file) {
                reject(undefined);
                return;
              }

              resolve({
                file,
                filePath: metaDto.filePath,
                id: metaDto.id,
                name: metaDto.name,
                createdAt: metaDto.createdAt,
              });
            })
            .catch(reject);
        }),
    );

    try {
      const response = await Promise.all(promises);
      return response;
    } catch {
      notices.error('Something went wrong during photo(s) loading');
    }

    return [];
  };

  return { getPhotos };
};
